<template>
  <UIAddRowButton
    aria-label="Insert row"
    :style="{ top: `${top}px` }"
    class="ui-grid__insert-button"
    @mousedown.prevent
  />
</template>

<script setup lang="ts">
import { UIAddRowButton } from '@ui/buttons'

type Props = {
  top?: number
}

defineProps<Props>()
</script>
